import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API, { ensureCsrfToken } from '../services/api';
import { loginErrorMessage } from "../utils/loginError";
import "./LoginPage.css"; // 🚀 اضافه کردن فایل استایل

const LoginPage = ({ setIsAuthenticated }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await ensureCsrfToken();
            const response = await API.post("/login/", {
                email,
                password,
            });
            localStorage.setItem("token", response.data.csrf_token);
            setIsAuthenticated(true);
            navigate("/");
        } catch (err) {
            setError(loginErrorMessage(err));
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleLogin}>
                <h2>Login</h2>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Login</button>
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
    );
};

export default LoginPage;
